import { Fragment, useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import close_icon_gray from "../../../assets/icons/close_icon_gray.svg";
import download_icon_white from "../../../assets/icons/download_icon_white.svg";
import backarrow_icon_white from "../../../assets/icons/backarrow_icon_white.svg";
import styles from "../../../assets/stylesheets/sass/AdminDashboard.module.scss";
import style from "../../../assets/stylesheets/sass/CustomerFiles.module.scss";
import localforage from "localforage";
import newfolder_icon from "../../../assets/icons/newfolder_iconX.svg";
import folder_icon from "../../../assets/icons/folder_iconX.svg";
import download_icon_gray from "../../../assets/icons/download_icon_gray.svg";
import pdf_icon from "../../../assets/icons/pdf_icon.svg";
import { ReactSession }  from 'react-client-session';
import { Document, Page, pdfjs   } from "react-pdf";
import { getUserSettings } from "../../../functions/fetch";
import { getFitDocToken, getFitDocTypes } from "../../../functions/token";
import { getFiles } from "../../../functions/files";
import LoadingStatus from "../../customComponents/LoadingStatus";
import LoadingContainer from "../../customComponents/LoadingContainer";
import { useSelector } from "react-redux";
import document from "../../../assets/icons/document.svg"
import { handleGetNewestInvoices } from "../../../functions/dashboard";
import { subMonths, subWeeks, subYears } from "date-fns";
import { getFilesNew } from "../../../functions/filesv2";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
let cont_state = {}
export function FileCards({value}){
    const allfiletypes = useSelector(state => state.filetypes)
    const navigate = useNavigate();

    const [animation, setanimation] = useState(0);
    const [showCard, setshowCard] = useState(true);
    const [fileTypes, setfileTypes] = useState(null);

    const handleClickCloseCard = () =>{
        setanimation(1);
        setTimeout(function(){setshowCard(false)}, 200)
    }

    const getDossierTypeName = (id) =>{
        if(fileTypes){
            for (let i = 0; i < fileTypes.length; i++) {
                if(fileTypes[i].dossiertypeid === id){
                    return fileTypes[i].name
                }
            }
        }
    }

    useEffect(()=>{
        let cancel = false;
        const getData = async () =>{
            let dossiertypes = allfiletypes
            if(dossiertypes){
                if (cancel) return;
                setfileTypes(dossiertypes);
            }
            else {
                fetch(process.env.REACT_APP_SERVER_LINK+"dossierTypes", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }).then(
                    res => res.json()
                ).then(
                    json => {
                        if(json.errorcode === 0){
                            if (cancel) return;
                            setfileTypes(json.object);
                        }
                    }
                )
            }
        }

        getData();

        return () => { 
            cancel = true;
        }
        
    }, [])

    const handleFileReadUpdate = (data) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"fileReadUpdate?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token+"&fileid="+data.fileid+"&read="+data.read, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({}),
        })
    }

    const handleOpenDossier = (value) =>{
        const name = value.nations[0].description;

        navigate('Dossiers/'+value.dossierentityid.toString()+"_"+name.replace(/ /g,"_"), {
            file: {id:value.dossierentityid, name:name.replace(/ /g,"_")},
        });

        const data = {
            "token": window.localStorage.getItem("token"),
            "read": 1,
            "fileid": value.dossierentityid
        }

        handleFileReadUpdate(data)
    }

    const filetypesTranslations = useSelector(state => state.filetypesTranslations)

    return (
        <>
        {showCard &&
        <div className={animation === 0 ? styles.files_card : styles.files_card_close_animation}>
            <div className={styles.card_content} onClick={()=>{handleOpenDossier(value)}}>
                <img className={styles.card_folder_icon} src={newfolder_icon} alt="folder"/>
                <p className={styles.card_dossier_type}>{getDossierTypeName(value.dossiertypeid) && filetypesTranslations[getDossierTypeName(value.dossiertypeid)][ReactSession.get("language")]}</p>
                <p className={styles.card_dossier_name}>{Array.isArray(value.nations) && value.nations[0].description}</p>
            </div>
        </div>
        }
        </>
    )
}

export default function CustomerDashboardComp(){
    const alldoctypes = useSelector(state => state.doctypes)
    const allfiletypes = useSelector(state => state.filetypes)
    const doctypesTranslations = useSelector(state => state.doctypesTranslations);
    const relation = useSelector(state => state.relation)

    const [hidden, sethidden] = useState(false);

    const [setrelation, setsetrelation] = useState("");
    const [newestInvoices, setnewestInvoices] = useState([]);
    const [name, setname] = useState("");
    const [role, setrole] = useState("");
    const [lastloggedin, setlastloggedin] = useState("");
    const [content_state, setcontent_state] = useState({});
    const [latestFiles, setlatestFiles] = useState([]);
    const [last_opened_docs, setlast_opened_docs] = useState([]);
    const [fullDoctypes, setfullDoctypes] = useState();
    const [loadingfiles, setloadingfiles] = useState({"status":"loading", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_searching && content_state[ReactSession.get("language")].Dashboard.status_files_searching) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_searching : "Searching files"+"..."});

    useEffect(()=>{
        let cancel = false;

        let user_data = JSON.parse(window.sessionStorage.getItem("user_data"));

        setname(user_data.firstname + " " + user_data.lastname);

        const getData = async () =>{

            fetch(process.env.REACT_APP_SERVER_LINK+"content").then(
                res => res.json()
            ).then(
                json => {
                    if (cancel) return;
                    setcontent_state(json)
                    cont_state = json;
                }
            )

            const getDoctypes = () =>{
                //Get documenttypes
                fetch(process.env.REACT_APP_SERVER_LINK+"documentTypes?token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data")))).then(
                    res => res.json()
                ).then(
                    json => {
                        if(json.errorcode === 0){
                            let doctypes = json.object;
                            localforage.setItem("docTypes", doctypes)

                            let fullDocTypes = {}
                            for (let j = 0; j < doctypes.length; j++) {
                                fullDocTypes[doctypes[j].doctype] = doctypes[j].docoms[0].oms;
                            }
                            setfullDoctypes(fullDocTypes);
                        }
                        else{
                            //console.log(json);
                            //console.log("Failed to get doctypes")
                        }
                    }
                )
            }

            let doctypes = alldoctypes

            if(doctypes){
                if(doctypes.length > 0){
                    let fullDocTypes = {}
                    for (let j = 0; j < doctypes.length; j++) {
                        fullDocTypes[doctypes[j].doctype] = doctypes[j].docoms[0].oms;
                    }
                    if (cancel) return;
                    setfullDoctypes(fullDocTypes);
                }
                else{
                    if (cancel) return;
                    getDoctypes();
                }
            }
            else{
                if (cancel) return;
                getDoctypes()
            }

            let roles = await localforage.getItem("roles"); 
            if(roles){
                for (let i = 0; i < roles.length; i++) {
                    if(roles[i].id.toString() === user_data.role){
                        if (cancel) return;
                        setrole(roles[i].role)
                    }             
                }
            }
            if (cancel) return;
            setloadingfiles({"status":"loading", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_searching && content_state[ReactSession.get("language")].Dashboard.status_files_searching) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_searching : "Searching files"+"..."});
            let dossiers = await localforage.getItem("dossiers");
            if(Array.isArray(dossiers)){
                let tmp_dossiers = dossiers.sort(function(a,b){
                    return new Date(b.creationdate) - new Date(a.creationdate);
                });
                const slicedArray = tmp_dossiers.slice(0, 4);
                if (cancel) return;
                
                if(checkLatestFiles(dossiers)){
                    if (cancel) return;
                    setloadingfiles({"status":"success", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_success && content_state[ReactSession.get("language")].Dashboard.status_files_success) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_success : "Files found"});
                    if (cancel) return;
                    setlatestFiles(slicedArray);
                }
                else{
                    if (cancel) return;
                    setloadingfiles({"status":"failed", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_nofound && content_state[ReactSession.get("language")].Dashboard.status_files_nofound) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_nofound : "No files found"});
                }
                
            }

            else {
                if (cancel) return;    

                let endDate = new Date();
                let ed = endDate.getDate().toString();
                if(ed.length < 2){ed = "0"+ed}
                let em = (endDate.getMonth() + 1).toString();
                if(em.length < 2){em = "0"+em}
                let ey = endDate.getFullYear().toString();
                endDate = ey + em + ed

                let startDate = subWeeks(new Date(), 1);
                if(JSON.parse(window.sessionStorage.getItem("user_data")).role.toString() !== "1"){
                    startDate = subMonths(new Date(), 6)
                }
                let sd = startDate.getDate().toString();
                if(sd.length < 2){sd = "0"+sd}
                let sm = (startDate.getMonth() + 1).toString();
                if(sm.length < 2){sm = "0"+sm}
                let sy = startDate.getFullYear().toString();
                startDate = sy + sm + sd

                let files = await getFilesNew(user_data, startDate, endDate)
                if(Array.isArray(files)){
                    if(files.length === 0){
                        setloadingfiles({"status":"success", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_nofound && content_state[ReactSession.get("language")].Dashboard.status_files_nofound) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_nofound : "No files found"});
                    }
                    else {
                        let tmp_dossiers = files.sort(function(a,b){
                            return new Date(b.creationdate) - new Date(a.creationdate);
                        });
                        const slicedArray = tmp_dossiers.slice(0, 4);
                        setlatestFiles(slicedArray);
                        localforage.setItem("dossiers", files);
                    }
                }
                else {
                    setloadingfiles({"status":"failed", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_nofound && content_state[ReactSession.get("language")].Dashboard.status_files_nofound) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_nofound : "No files found"});
                }

                // getFiles(user_data, startDate, endDate).then(
                //     res => {
                //         if(Array.isArray(res)){
                //             let tmp_dossiers = res.sort(function(a,b){
                //                 return new Date(b.creationdate) - new Date(a.creationdate);
                //             });
                //             const slicedArray = tmp_dossiers.slice(0, 4);
                //             if(checkLatestFiles(res)){
                //                 if (cancel) return;
                //                 setloadingfiles({"status":"success", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_success && content_state[ReactSession.get("language")].Dashboard.status_files_success) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_success : "Files found"});
                //                 setlatestFiles(slicedArray);
                //                 localforage.setItem("dossiers", res);
                //             }
                //             else{
                //                 if (cancel) return;
                //                 setloadingfiles({"status":"failed", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_nofound && content_state[ReactSession.get("language")].Dashboard.status_files_nofound) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_nofound : "No files found"});
                //             }                         
                //         }
                //         else{
                //             if(res === "none"){
                //                 if (cancel) return;
                //                 setloadingfiles({"status":"failed", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_nofound && content_state[ReactSession.get("language")].Dashboard.status_files_nofound) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_nofound : "No files found"});
                //                 return
                //             }
                //             else{   
                //                 setloadingfiles({"status":"failed", "message":content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.status_files_failed && content_state[ReactSession.get("language")].Dashboard.status_files_failed) : cont_state[ReactSession.get("language")] ? cont_state[ReactSession.get("language")].Dashboard.status_files_failed : "File search failed"});
                //                 return;
                //             }
                //         }
                //     }
                // )
            }

            localforage.getItem("newest_invoices").then(
                res => {
                    if (cancel || !Array.isArray(res)) return;
                    setnewestInvoices(res.slice(0, 5));
                }
            )

            localforage.getItem("last_opened_docs").then(
                res => {
                    if (cancel || !Array.isArray(res)) return;
                    localforage.getItem("userSettings").then(
                        usersettings => {
                            if(usersettings.json.last_opened_files){
                                setlast_opened_docs(res)
                            }
                        }
                    )
                }
            )

            let userSettings = await localforage.getItem("userSettings");
            if(userSettings){
                if(userSettings.json.last_opened_files){
                let last_opened_files = userSettings.json.last_opened_files;
                let searchstring = "";

                if(Array.isArray(last_opened_files)){
                    for (let i = 0; i < last_opened_files.length; i++) {
                        searchstring += `=#DOCID:${last_opened_files[i]} `
                    }
                }    
                
                let ssbdoctypes = await getFitDocTypes()
                
                let searchStartBody = {
                    "token": getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))),
                    "searchstring": searchstring,
                    "doctypes":ssbdoctypes.join(";"),
                    "startdate": "",
                    "enddate": "",
                    "searchcontent": 0,
                    "amountdocs": 5
                }

                fetch(process.env.REACT_APP_SERVER_LINK+"searchStart", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(searchStartBody),
                }).then(
                    res => res.json()
                ).then(
                    json => {
                        if(json.errorcode === 0){
                            fetch(process.env.REACT_APP_SERVER_LINK+"searchList?searchid="+json.object.searchid+"&token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))), {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                }
                            }).then(
                                res => res.json()
                            ).then(
                                json => {
                                    if (cancel || !Array.isArray(json.object)) return;
                                    if(json.errorcode === 0){
                                        setlast_opened_docs(json.object);
                                        localforage.setItem("last_opened_docs", json.object)
                                    }else{
                                        //console.log(json)
                                    }
                                }
                            )
                        }
                    }
                )
                }
            }
            else {
                getUserSettings(JSON.parse(window.sessionStorage.getItem("user_data"))).then(
                    res => {
                        if(res.object){
                            if(res.object.json.last_opened_files){
                                let searchstring = "";
                                
                                if(res.object.json.last_opened_files){
                                    for (let i = 0; i < res.object.json.last_opened_files.length; i++) {
                                        searchstring += `=#DOCID:${res.object.json.last_opened_files[i]} `
                                    }
                                }

                                const loadingLastOpenedFiles = async () =>{
                                    let ssbdoctypes = await getFitDocTypes()
                                    let searchStartBody = {
                                        "token": getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))),
                                        "searchstring": searchstring,
                                        "doctypes": ssbdoctypes.join(";"),
                                        "startdate": "",
                                        "enddate": "",
                                        "searchcontent": 0,
                                        "amountdocs": 5
                                    }

                                    fetch(process.env.REACT_APP_SERVER_LINK+"searchStart", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify(searchStartBody),
                                    }).then(
                                        res => res.json()
                                    ).then(
                                        json => {
                                            if(json.errorcode === 0){
                                                fetch(process.env.REACT_APP_SERVER_LINK+"searchList?searchid="+json.object.searchid+"&token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))), {
                                                    method: "GET",
                                                    headers: {
                                                        "Content-Type": "application/json",
                                                    }
                                                }).then(
                                                    res => res.json()
                                                ).then(
                                                    json => {
                                                        if (cancel || !json.object) return;
                                                        setlast_opened_docs(json.object);
                                                        localforage.setItem("last_opened_docs", json.object)
                                                    }
                                                )
                                            }
                                            else{
                                                //console.log("lof failed", json);
                                            }
                                        }
                                    )
                                }

                                loadingLastOpenedFiles();
                                
                            }  
                            else {
                                //console.log("No last opened files")
                            }           
                        }
                        else{
                            //console.log(res);
                        }
                    }
                )
            }

            //Newest invoices
            const nwi = await handleGetNewestInvoices(JSON.parse(window.sessionStorage.getItem("user_data")))
            if(nwi.errorcode === 0 && Array.isArray(nwi.object)){
                if (cancel) return;
                
                const slicedArray = nwi.object.slice(0, 5);
                setnewestInvoices(slicedArray);
                localforage.setItem("newest_invoices", slicedArray);
            }
        }

        const lli = new Date(user_data.lastlogin).toLocaleString(setLocaleString(ReactSession.get("language")), { day:"numeric", month: 'long',year:"numeric" })
        if (cancel) return;
        setlastloggedin(lli);

        if (cancel) return;
        getData();


        return () => { 
            cancel = true;
        }
    }, [])

    useEffect(()=>{
        const lli = new Date(JSON.parse(window.sessionStorage.getItem("user_data")).lastlogin).toLocaleString(setLocaleString(ReactSession.get("language")), { day:"numeric", month: 'long',year:"numeric" })
        setlastloggedin(lli);
    }, [ReactSession.get("language")])

    const getFullDoctype = (short_type) =>{
        if(fullDoctypes){
            if(fullDoctypes[short_type]){
                return fullDoctypes[short_type];
            }
        }
        
        else {
            return short_type
        }
    }

    const [viewPreview, setviewPreview] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [file_base64, setfile_base64] = useState("");
    const [file_docid, setfile_docid] = useState("");

    const handleViewDocument = (e) =>{
        setloadingfiles({"status":"loading", "message":"Opening document..."});
        setfile_base64("")
        setfile_docid("")
        setNumPages(null);
        fetch(process.env.REACT_APP_SERVER_LINK+"documents?docid="+e.currentTarget.id+"&token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then(
            res => res.json()
        ).then(
            json => {
                let res = json.object;
                if(json.errorcode === 0){                 
                    setfile_base64(res.file);
                    setfile_docid(res.docid.toString())
                    setviewPreview(true);
                    setloadingfiles({"status":"success", "message":"Document opened"});
                    setTimeout(function(){setloadingfiles(null)}, 5000)
                }   
                else{
                    setfile_docid("Failed to load")
                    setloadingfiles({"status":"success", "message":"Document opening failed"});
                    setTimeout(function(){setloadingfiles(null)}, 5000)
                }    
            }
        )
    }

    const handleDownloadDocument = (e) =>{
        setloadingfiles({"status":"success", "message":"Document downloading..."})

        fetch(process.env.REACT_APP_SERVER_LINK+"documents?docid="+e.currentTarget.id+"&token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    function downloadPDF(pdf) {
                        const linkSource = `data:application/pdf;base64,${pdf}`;
                        const downloadLink = window.document.createElement("a");
                        const fileName = `document_${json.object.docid}.pdf`;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                        setloadingfiles({"status":"success", "message":"Document downloaded"})
                        setTimeout(function(){setloadingfiles(null)}, 5000)
                    }

                    downloadPDF(json.object.file)
                }
                else{
                    setloadingfiles({"status":"failed", "message":"Document downloading failed"})
                    setTimeout(function(){setloadingfiles(null)}, 5000)
                }
            }
        )
    }

    const checkLatestFiles = (files) =>{
        const hasDocuments = (currentValue) => currentValue.documents && currentValue.documents.length > 0;
    
        if(!Array.isArray(files)){return false;}
        if(files.length > 0){
            return files.some(hasDocuments);
        }
        else{
            return false;
        }
    }

    const setLocaleString = (language) =>{
        if(language === "N"){
            return "nl-BE"
        }
        else if(language === "F"){
            return "fr-FR"
        }
        else{
            return "en-GB"
        }
    }

    const checkInvoiceIsApproved = (invoice) => {
        let approved = false;
        for (let i = 0; i < invoice.metadata.length; i++) {
            if(invoice.metadata[i].metatype === "GOEDKEURD"){
                if(invoice.metadata[i].metatype.metavalue !== ""){
                    approved = true;
                }
            }
        }
        return approved
    }

	return (
	    <>	
        {loadingfiles &&
        <LoadingContainer hide={false}>
            <LoadingStatus message={loadingfiles.message} loadingIcon status={loadingfiles.status}/>
        </LoadingContainer>
        }
        
        
        <div className={styles.content}>
            <div className={styles.person_container}>
                <div className={styles.person_information}>
                    <div className={styles.profile_picture}><p>{relation ? (relation.name ? relation.name.charAt(0) : name.charAt(0)) : name.charAt(0)}</p></div>
                    <div className={styles.person_information_text}>
                        <p className={styles.person_name}>{relation && relation.name || name}</p>
                        {/* <p className={styles.person_profession}>{role}</p> */}
                    </div>
                </div>
                <div className={styles.statistics_content}>
                    <div className={styles.person_box}>
                        <p className={styles.statistic_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.statistic_title_lastloggedin && content_state[ReactSession.get("language")].Dashboard.statistic_title_lastloggedin) : "Last logged in"}</p>
                        <p className={styles.statistic_text}>{lastloggedin}</p>
                    </div>
                </div>
            </div>  

            {Array.isArray(newestInvoices) && newestInvoices.length > 0 && 
            <div className={styles.newestfiles_container}>
                <p className={styles.dashboard_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.newestinvoices_titlle && content_state[ReactSession.get("language")].Dashboard.newestinvoices_titlle) : "Latest invoices"}</p>
                <div className={styles.invoice_cards}>
                    {newestInvoices && Array.isArray(newestInvoices) && newestInvoices.map((v, i)=>{
                        return (
                            <div className={styles.invoice_card} key={i} id={v.docid} onClick={(e)=>{handleViewDocument(e)}}>
                                <div className={styles.invoice_content}>
                                    <img src={document} alt="document"/>
                                    <div className={styles.invoice_info}>
                                        <p className={styles.invoice_name}>{doctypesTranslations && doctypesTranslations[v.doctype] && doctypesTranslations[v.doctype][ReactSession.get("language")]} - {v.docid}</p>
                                        <p className={styles.invoice_date}>{new Date(((v.docdate.substring(4, 6)+"-"+v.docdate.substring(6, 8)+"-"+v.docdate.substring(0, 4)).toString())).toLocaleString(setLocaleString(ReactSession.get("language")), { day:"numeric", month: 'long',year:"numeric" })}</p>
                                    </div>
                                </div>
                                {/* <p className={styles.invoice_status} style={checkInvoiceIsApproved(v) ? {backgroundColor:"#089852"} : {backgroundColor:"#FE5819"}}>{checkInvoiceIsApproved(v) ? (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.newestinvoices_approved && content_state[ReactSession.get("language")].Dashboard.newestinvoices_approved) : "Approved") : (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.newestinvoices_notapproved && content_state[ReactSession.get("language")].Dashboard.newestinvoices_notapproved) : "Not approved")}</p> */}
                            </div>
                        )
                    })}

                    
                </div>
            </div>
            }

            <div className={styles.newestfiles_container}>
                {(Array.isArray(latestFiles) && latestFiles.length > 0 && checkLatestFiles(latestFiles)) ? 
                <>
                {(latestFiles.length > 0) ?
                    <>
                    <p className={styles.dashboard_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.title_newest_files && content_state[ReactSession.get("language")].Dashboard.title_newest_files) : "Newest files"}</p>
                    <div className={styles.filesgroup_container}>
                        {latestFiles.map((v, i)=>{
                            if(v.documents.length > 0){
                                return (
                                    <Fragment key={i}>
                                        <FileCards value={v}/>
                                    </Fragment>
                                )
                            }
                            
                        })}        
                    </div>
                    </>
                    :
                    loadingfiles && loadingfiles.status !== "failed" && 
                    <>
                    <p className={styles.dashboard_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard.title_newest_files && content_state[ReactSession.get("language")].Dashboard.title_newest_files) : "Newest files"}</p>
                        <LoadingCards folder_icon={folder_icon}  />
                    </>
                }     
                </>
                :
                (loadingfiles && loadingfiles.status !== "failed") && 
                <>
                    <p className={styles.dashboard_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard && content_state[ReactSession.get("language")].Dashboard.title_newest_files && content_state[ReactSession.get("language")].Dashboard.title_newest_files) : "Newest files"}</p>
                    <LoadingCards folder_icon={folder_icon}  />
                </>
                }
            </div>

            {viewPreview && 
                <div className={styles.document_preview}>
                    <div className={styles.document_preview_header}>
                        <button onClick={()=>{setviewPreview(false)}}><img src={backarrow_icon_white} alt="icon"/><p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Documents && content_state[ReactSession.get("language")].Documents.labelpreview_back && content_state[ReactSession.get("language")].Documents.labelpreview_back) : "Back"}</p></button>
                        <h2 className={styles.document_preview_title}>{file_docid ? "Document - " + file_docid : (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files && content_state[ReactSession.get("language")].Files.pdf_preview_loading && content_state[ReactSession.get("language")].Files.pdf_preview_loading) : "Patience...")}</h2>
                        <button>{file_docid && <a download={"document_" + file_docid} title={"document_" + file_docid} href={"data:application/pdf;base64,"+file_base64}><img src={download_icon_white} alt="icon"/></a>}</button>
                    </div>
                    <div className={styles.pdf_viewer}>
                        <Document
                        loading={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files && content_state[ReactSession.get("language")].Files.pdf_preview_loading && content_state[ReactSession.get("language")].Files.pdf_preview_loading) : "Patience..."}
                        onLoadSuccess={({ numPages })=>setNumPages(numPages)}
                        file={"data:application/pdf;base64,"+file_base64}
                        >
                            {Array.apply(null, Array(numPages))
                            .map((x, i)=>i+1)
                            .map(page => <div key={page} style={{marginBottom:"1.5rem"}}><Page pageNumber={page}/></div>)}
                            
                        </Document>
                    </div>
                    <div className={styles.document_preview_bg} onClick={()=>{setviewPreview(false)}}></div>
                </div>
            }


            {last_opened_docs && 
            <>
            {last_opened_docs.length > 0 && 
            <div className={styles.newestfiles_container}>
                <p className={styles.dashboard_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard.title_lastopened_files && content_state[ReactSession.get("language")].Dashboard.title_lastopened_files) : "Last opened files"}</p>
                <div className={styles.documents_container}>
                    <table className={style.table}>
                        <tbody>

                            <tr className={style.table_header}>
                                <th style={{width:"3rem"}}></th>
                                <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard.lastopened_table_files && content_state[ReactSession.get("language")].Dashboard.lastopened_table_files) : "File"}</th>
                                <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard.lastopened_table_type && content_state[ReactSession.get("language")].Dashboard.lastopened_table_type) : "Type"}</th>
                                <th style={{width:"10rem"}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard.lastopened_table_date && content_state[ReactSession.get("language")].Dashboard.lastopened_table_date) : "Added on"}</th>
                                <th style={{width:"3rem"}}></th>
                            </tr>
                            {last_opened_docs.map((v, i)=>{
                                return (
                                    <tr key={i} className={styles.document_row}>
                                        <td id={v.docid} onClick={(e)=>{handleViewDocument(e)}} className={style.dossier_icon}>
                                            <img src={pdf_icon} alt="pdf icon"/>
                                        </td>
                                        <td id={v.docid} onClick={(e)=>{handleViewDocument(e)}} className={style.document_text}>Document - {v.docid}</td>
                                        <td id={v.docid} onClick={(e)=>{handleViewDocument(e)}} className={style.document_text_type}>{doctypesTranslations && doctypesTranslations[v.doctype] && doctypesTranslations[v.doctype][ReactSession.get("language")]}</td>                       
                                        <td id={v.docid} onClick={(e)=>{handleViewDocument(e)}} className={style.document_text_date}>{new Date(((v.docdate.substring(4, 6)+"-"+v.docdate.substring(6, 8)+"-"+v.docdate.substring(0, 4)).toString())).toLocaleString(setLocaleString(ReactSession.get("language")), { day:"numeric", month: 'long',year:"numeric" })}</td>
                                        <td style={{textAlign:"center"}} className={styles.table_downloadtag}>
                                            
                                                <div className={style.download_button} id={v.docid} onClick={(e)=>{handleDownloadDocument(e)}}>
                                                    <img src={download_icon_gray} alt="icon"/>
                                                    <span className={style.tooltiptextAdmin}>Download document</span>
                                                </div>
                                            
                                        </td>
                                    </tr>
                                )
                            })}                                    
                        </tbody>
                    </table>
                </div>
            </div>
            }
            </>
            }
        </div>  
	    </>  
  	);

    function LoadingCards({folder_icon}) {
      return (<div className={styles.filesgroup_container}>
                    <div className={styles.files_card_loading}>
                        <div className={styles.card_content}>
                            <img className={styles.card_folder_icon} src={folder_icon} alt="folder" />
                            <p className={styles.card_dossier_type_loading}></p>
                            <p className={styles.card_dossier_name_loading}></p>
                        </div>
                    </div>
                    <div className={styles.files_card_loading}>
                        <div className={styles.card_content}>
                            <img className={styles.card_folder_icon} src={folder_icon} alt="folder" />
                            <p className={styles.card_dossier_type_loading}></p>
                            <p className={styles.card_dossier_name_loading}></p>
                        </div>
                    </div>
                    <div className={styles.files_card_loading}>
                        <div className={styles.card_content}>
                            <img className={styles.card_folder_icon} src={folder_icon} alt="folder" />
                            <p className={styles.card_dossier_type_loading}></p>
                            <p className={styles.card_dossier_name_loading}></p>
                        </div>
                    </div>
                </div>);
    }
    }